<template>
  <div class="fadeIn max-[300px]:mt-10 w-full grid max-[300px]:grid-cols-1  min-[301px]:grid-cols-2  justify-items-center justify-center items-center bg-eggplant-980 py-2 mt-5">
    <div class="flex gap-x-1 md:gap-x-2.5 text-xs max-[300px]:hidden items-center " >
      <img draggable="false" src="../../assets/logo2.svg" alt="Logo" class="inline max-sm:size-12 size-10">
      <div class="flex flex-col md:justify-center md:align-middle items-start text-sm md:text-center">
        <div>© {{(new Date()).getFullYear()}}</div>
        <div>{{$t('home.profile.name')}}</div>
      </div>
    </div>
    <div class="flex flex-wrap flex-col justify-center items-center  space-x-10 max-md:space-x-6 max-[300px]:space-x-0">
        <p class="text-center inline align-center font-semibold">{{$t('connect')}}</p>
        <Links class="brightness-150" />
    </div>
  </div>
</template>
